import { createContext, useContext } from "react";
import { MapEditorActionsState } from "./MapEditorContext.types";

export const MapEditorActionsContext =
  createContext<MapEditorActionsState | null>(null);

export const useMapEditorActions = (): MapEditorActionsState => {
  const context = useContext(MapEditorActionsContext);
  if (!context) {
    throw new Error(
      "useMapEditorActions must be used within a MapEditorProvider"
    );
  }
  return context;
};
